import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/vendor/consignment-stock-out/$id/detail",
)({
	component: () => null,
});
